<template>
  <b-row class="mt-4 d-flex justify-content-center">
    <b-col class="d-md-none d-lg-block">
      <!-- <b-button size="sm" variant="primary"
        ><strong>Email</strong> this to me</b-button
      > -->
    </b-col>
    <b-col xl="12" class="text-center pl-5 pr-5 col-xxl-7">
      <h4 class="light-header">
        Design and Personalise your own Discovery Bank 
        <span class="colour-underline"><strong>Shared-Value</strong></span> Rewards Stack
      </h4>
      <p class="pt-5">
        <strong>Start by selecting</strong> a Discovery Bank card colour,
        account type and Vitality Money status
      </p>
    </b-col>
    <b-col class="display-none-custom only-display-on-largest-screen">
      <b-button size="sm" @click="newCompare()" class="btn-white float-right"
        >Click to
        <span v-if="compared == 1"
          ><strong>compare</strong> another account <img src="@/assets/images/icons/add-icon.png" alt="" ></span
        >
        <span v-if="compared == 2">
          <strong>go back</strong> your account <img src="@/assets/images/icons/subtract-icon.png" alt="" >
        </span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    compared: {
      default: 1,
    },
  },
  methods: {
    newCompare() {
      if (this.compared == 2) {
        this.$emit("reduce");
      } else {
        this.$emit("add");
      }
    },
  },
};
</script>

<style>
</style>